module.exports = __webpack_public_path__ + "static/media/error.026b331a.png";